export const groupBy = (xs, key) => {
  return convertData(
    xs.reduce(function (rv, x) {
      if (!rv[x[key]]) {
        rv[x[key]] = [];
      }
      rv[x[key]].push(x);
      return rv;
    }, {})
  );
};

const convertData = (items) => {
  const data = [];
  for (const [index, [key, value]] of Object.entries(Object.entries(items))) {
    const body = {
      id: index,
      Name: key,
      ValueCurrentDTOs: [...value],
    };
    data.push(body);
  }
  return data;
};
